import { render, staticRenderFns } from "./AIBotLoading.vue?vue&type=template&id=f73e53bc&scoped=true"
import script from "./AIBotLoading.vue?vue&type=script&lang=ts"
export * from "./AIBotLoading.vue?vue&type=script&lang=ts"
import style0 from "./AIBotLoading.vue?vue&type=style&index=0&id=f73e53bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73e53bc",
  null
  
)

export default component.exports